<template>
  <b-card class="ba-h-full ba-overflow-auto">
    <div class="ba-w-48 ba-mb-4">
      <div ref="container"></div>
    </div>
    <div class="ba-w-48">
      <dx-date-box
        class="date-input"
        type="datetime"
        useButtons="true"
        :placeholder="`${$t('editors.select')}`"
        :read-only="false"
        :show-clear-button="true"
        :open-on-field-click="false"
      >
      </dx-date-box>
    </div>
  </b-card>
</template>

<script>
import DateBox from "devextreme/ui/date_box";
import { DxDateBox } from "devextreme-vue/date-box";
export default {
  name: "v-dx-datebox-page",
  components: {
    DxDateBox
  },
  mounted() {
    const widget = new DateBox(this.$refs.container, {
      type: "datetime",
      placeholder: "Enter Datetime"
    });
  }
};
</script>
